<template>
  <div class="projectData">
    <el-form :model="queryInfo" class="ly-header__bg" label-width="100px">
      <el-form-item label="所在地区：">
        <EarthAreaSelect
          :country="queryInfo.country"
          :province="queryInfo.province"
          :city="queryInfo.city"
          :region="queryInfo.region"
          @searchCountry="searchCountry"
          @searchProvince="searchProvince"
          @searchCity="searchCity"
        />
      </el-form-item>
      <el-form-item label="所属行业：">
        <SelectTreeRadio
          apiName="getIndustryThree"
          resultType="values"
          storageKey="industryCategory"
          v-model="queryInfo.industryCategory"
          @input="(e) => labelTagChange('industryCategory', e, '所属行业')"
        ></SelectTreeRadio>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="组织类型：">
            <SelectTreeRadio
              apiName="getDicRadioButton"
              :params="{ code: '047' }"
              resultType="values"
              vFeild="codeId"
              lFeild="codeName"
              storageKey="organizationType"
              v-model="queryInfo.organizationType"
              @input="(e) => labelTagChange('organizationType', e, '组织类型')"
            ></SelectTreeRadio>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="组织级别：">
            <SelectTreeRadio
              apiName="getDicRadioButton"
              :params="{ code: '047' }"
              resultType="values"
              vFeild="codeId"
              lFeild="codeName"
              storageKey="organizationLevel"
              v-model="queryInfo.organizationLevel"
              @input="(e) => labelTagChange('organizationLevel', e, '组织级别')"
            ></SelectTreeRadio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="成立时间：">
            <SelectTreeRadio
              apiName="getDicRadioButton"
              :params="{ code: '047' }"
              resultType="values"
              vFeild="codeId"
              lFeild="codeName"
              storageKey="establishmentTime"
              v-model="queryInfo.establishmentTime"
              @input="(e) => labelTagChange('establishmentTime', e, '成立时间')"
            ></SelectTreeRadio>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="筛选条件：" class="filterInfo">
        <el-tag
          closable
          v-for="(item, index) in tags"
          :key="index + item.name"
          @close="closeTag(index, item.tagName)"
        >
          {{ item.name }}：{{
            queryInfo[item.tagName] ? queryInfo[item.tagName] : "不限"
          }}
          <span
            class="circle"
            v-if="item.hasOwnProperty('valLength') && item.valLength > 0"
            >+{{ item.valLength }}</span
          >
        </el-tag>
      </el-form-item>
    </el-form>
    <div class="ly-container__bg">
      <div class="ly_operation">
        <div class="left">
          <ImportFilePopup
            moduleName="智参企业"
            templateUrl="/template/智参企业上传.xlsx"
            buttonText="批量上传企业"
            popupTitle="批量新增智参企业"
            templateName="智参企业"
            @uploadSuccess="search"
          />

          <el-button @click="multiDelete">
            批量删除
            <i class="jr-iconjr-icon-delect" />
          </el-button>

          <el-button @click="multiDelete">
            批量导出
            <i class="jr-iconjr-icon-export" />
          </el-button>

          <!-- <popover @popoverClick="popoverClick" /> -->

          <div class="upload_time">
            <div class="caretTime" @click="uploadTime" style="color: #606266">
              按创建时间
            </div>
            <i
              class="el-icon-caret-top"
              :class="[
                queryInfo.columnName == 'create_time' && queryInfo.order == 0
                  ? 'isActiveTime1'
                  : 'iconColor',
              ]"
            />
            <i
              class="el-icon-caret-bottom"
              :class="[
                queryInfo.columnName == 'create_time' && queryInfo.order == 1
                  ? 'isActiveTime1'
                  : 'iconColor',
              ]"
            />
          </div>
        </div>

        <MySearchInput
          placeholderTxt="根据姓名、昵称进行搜索"
          v-model="queryInfo.name"
          @on-search="search"
          @on-clear="search"
          @on-enter="search"
        ></MySearchInput>
      </div>

      <el-table
        class="ly_table"
        :data="projectTable"
        v-loading="loading"
        :header-cell-style="{ background: '#F5F6F7', color: '#363E4D' }"
        @selection-change="handleSelectionChange"
        :default-sort="{ prop: 'date', order: 'descending' }"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55" align="center" />

        <template slot="empty">
          <img src="@/assets/img/table.png" alt="没有数据" srcset="" />
        </template>

        <!-- 编号列 -->
        <el-table-column label="编号" align="center" width="100" prop="id">
        </el-table-column>

        <!-- 数据完整度列 -->
        <el-table-column label="数据完整度" align="center" width="100">
          <template #default="{ row }">
            <el-progress
              type="circle"
              :width="50"
              :percentage="row.dataIntegrity"
              :color="customColorMethod(row.dataIntegrity)"
            ></el-progress>
          </template>
        </el-table-column>

        <!-- 数据质量列（带进度条效果） -->
        <el-table-column label="数据质量" align="center" width="80">
          <template #default="{ row }"> {{ row.dataQuality }}</template>
        </el-table-column>

        <!-- 企业logo -->
        <el-table-column label="企业logo" width="120" align="center">
          <template #default="{ row }">
            <el-avatar :size="50" :src="row.logo" v-if="row.logo" />
            <el-avatar :size="50" v-else>{{ row.name.charAt(0) }}</el-avatar>
          </template>
        </el-table-column>

        <!-- 名称 -->
        <el-table-column prop="name" label="名称" width="180" />

        <!-- 类型 -->
        <el-table-column prop="type" label="类型" width="120" />

        <!-- 级别 -->
        <el-table-column prop="level" label="级别" width="120" />

        <!-- 成立日期 -->
        <el-table-column
          prop="establishDate"
          label="成立日期"
          width="150"
          align="center"
        />

        <!-- 运营状态 -->
        <el-table-column label="运营状态" prop="status" width="120" align="center">
          <!-- <template #default="{ row }">
            <el-tag :type="row.status === '运营中' ? 'success' : 'warning'">
              {{ row.status }}
            </el-tag>
          </template> -->
        </el-table-column>

        <!-- 介绍 -->
        <el-table-column
          prop="description"
          label="介绍"
          width="250"
          show-overflow-tooltip
        />

        <!-- 联系方式 -->
        <el-table-column
          prop="contact"
          label="联系方式"
          width="150"
          align="center"
        />

        <!-- 主管机构 -->
        <el-table-column prop="governingBody" label="主管机构" width="150" />

        <!-- 业务类型 -->
        <el-table-column prop="businessType" label="业务类型" width="150" />

        <!-- 所在地区 -->
        <el-table-column prop="location" label="所在地区" width="180" />

        <!-- 创建日期 -->
        <el-table-column
          prop="createDate"
          label="创建日期"
          width="150"
          align="center"
        />

        <el-table-column label="操作" width="140" align="center">
          <template v-slot="{ row }">
            <div class="flex_top">
              <button-table
                @buttonClick="editItem(row)"
                content="编辑"
                icon="jr-iconjr-icon-edit"
              />
              <button-table
                @buttonClick="deleteItem(row)"
                content="删除"
                icon="jr-iconjr-icon-delect"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 30, 50, 100, 200]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
import ImportFilePopup from "@/components/ImportFilePopup/index.vue";
import ButtonTable from "@/components/ButtonTable.vue";
import EarthAreaSelect from "@/components/EarthAreaSelect";
// import Popover from "@/components/Popover.vue";

export default {
  components: {
    SelectTreeRadio,
    ImportFilePopup,
    ButtonTable,
    EarthAreaSelect,
  },
  data() {
    return {
      loading: false,
      total: 2,
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
        industryCategory: "",
        name: "",
        columnName: "create_time",
        order: 1, // 0正序 1倒叙
        country: "中国", // 国家
        province: "", // 省份
        city: "", // 城市
        region: "",
        establishmentTime: "",
        organizationLevel: "",
        organizationType: "",
      },
      projectTable: [
        {
          id: "CTQY39410",
          dataIntegrity: 95,
          dataQuality: "G",
          logo: "",
          name: "中国国际商会",
          type: "传统商会",
          level: "国家级",
          establishDate: "2021年12月1日",
          status: "运营中",
          description: "非营利性社会组织，具备互...",
          contact: "18545278816",
          governingBody: "BRR",
          businessType: "外贸规则",
          location: "湖南-长沙-开福",
          createDate: "2021年12月1日",
        },
        {
          id: "CTQY39410",
          dataIntegrity: 95,
          dataQuality: "G",
          logo: "",
          name: "中国国际商会",
          type: "传统商会",
          level: "国家级",
          establishDate: "2021年12月1日",
          status: "运营中",
          description: "非营利性社会组织，具备互...",
          contact: "18545278816",
          governingBody: "BRR",
          businessType: "外贸规则",
          location: "湖南-长沙-开福",
          createDate: "2021年12月1日",
        },
      ],
      customColors: [
        { color: "#1E9FFF", percentage: 20 },
        { color: "#1E9FFF", percentage: 40 },
        { color: "#1E9FFF", percentage: 60 },
        { color: "#1E9FFF", percentage: 80 },
        { color: "#1E9FFF", percentage: 100 },
      ],
      tags: [
        {
          name: "成立时间",
          tagName: "establishmentTime",
        },
        {
          name: "所属行业",
          tagName: "industryCategory",
        },
        {
          name: "组织级别",
          tagName: "organizationLevel",
        },
        {
          name: "组织类型",
          tagName: "organizationType",
        },
      ],
    };
  },
  methods: {
    customColorMethod(percentage) {
      return (
        this.customColors.find((color) => percentage <= color.percentage)
          ?.color || "#1E9FFF"
      );
    },
    multiDelete(e) {},
    search() {},
    popoverClick() {},
    uploadTime() {},
    handleSelectionChange() {},
    sortChange() {},
    handleSizeChange() {},
    handleCurrentChange() {},
    editItem(row) {
      this.$router.push({
        path: "/chamber/detail",
        query: {
          id: row.id,
          companyCode: row.companyCode,
          enterpriseType: 1,
        },
      });
    },
    // tag标签关闭
    closeTag(index, name) {
      this.tags.splice(index, 1);

      switch (name) {
        case "industryCategoryList":
          this.queryInfo.industryCategoryListName = "";
          this.queryInfo.industryCategoryList = [];
          break;
        default:
          this.queryInfo[name] = "";
          break;
      }
    },
    deleteItem() {},
    searchCountry() {},
    searchProvince() {},
    searchCity() {},
  },
};
</script>

<style lang="less" scoped>
.projectData {
  /deep/ .el-input-group__append {
    background: #1e9fff;
    color: #fff;
    border: 1px solid #1e9fff;
  }
  .caretTime:hover {
    cursor: pointer;
  }
  .flex_top {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .color1 {
    color: #34c759;
  }
}
.isActiveTime1 {
  color: #1e9fff !important;
}
.iconColor {
  color: #c0c4cc !important;
}
/deep/ .filterInfo .el-form-item__content {
  padding: 0;
}
</style>